import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { RiFileExcel2Fill } from "react-icons/ri"
import { useMutation, useQueryClient } from "@tanstack/react-query"

type importDataSiswaState = {
  tahun: string
  file: File | null
  fileName: string
}

const importDataPrestasi = async (newData: FormData) => {
  const response = await api.post("/import/penerimaan/data-prestasi", newData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return response.data
}

export default function FormImport({ closeModal }: { closeModal: () => void }) {
  const [form, setForm] = useState<importDataSiswaState>({
    tahun: "",
    file: null,
    fileName: "",
  })

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0]
    if (file) setForm({ ...form, file: file, fileName: file.name })
  }

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: importDataPrestasi,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listDataPrestasi"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData()
    formData.append("tahun", form.tahun)
    if (form.file) formData.append("file", form.file)
    mutate(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader title="Import Data Prestasi" icon={<RiFileExcel2Fill />} />
      <div>
        <Label>Tahun</Label>
        <Input
          required
          placeholder="Ketik tahun..."
          value={form.tahun}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, tahun: event.target.value }))
          }
        />
      </div>
      <div>
        <Label>File Excel</Label>
        <Input required type="file" onChange={handleFileChange} />
        {form.file && (
          <p className="text-sm text-muted-foreground">
            Selected file: {form.fileName}
          </p>
        )}
      </div>

      <div className="mt-3 flex gap-3">
        <Button type="button" onClick={closeModal} disabled={isPending}>
          Batal
        </Button>
        <Button
          variant={"outline"}
          className="flex items-center gap-3"
          disabled={isPending}
        >
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Import"
          )}
        </Button>
      </div>
    </form>
  )
}
